const FITTING_NONE = 0;
const FITTING_STRETCH = 1;
const FITTING_SHRINK = 2;
const FITTING_BOTH = 3;

export { FITTING_BOTH, FITTING_NONE, FITTING_SHRINK, FITTING_STRETCH };
